module.exports = __webpack_public_path__ + "static/img/0542_9.cf6a016.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0542_9.jpg
// module id = aH+y
// module chunks = 1